import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleFetchActions = createDataModuleActions('FETCH_FEATURE_SWITCH');

export const fetchFeatureSwitchRequest = dataModuleFetchActions.dataRequest;
export const fetchFeatureSwitchSuccess = dataModuleFetchActions.dataSuccess;
export const fetchFeatureSwitchError = dataModuleFetchActions.dataError;
export const fetchFeatureSwitchReset = dataModuleFetchActions.dataReset;
